import { render, staticRenderFns } from "./diagram.vue?vue&type=template&id=5f3e3597"
import script from "./diagram.vue?vue&type=script&lang=js"
export * from "./diagram.vue?vue&type=script&lang=js"
import style0 from "./diagram.vue?vue&type=style&index=0&id=5f3e3597&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports